module.exports = __webpack_public_path__ + "img/icons8-box-important-100.26d9cb27.png";